<template>
  <div style="height: calc(100vh - 135px);overflow: auto;padding-right:3px">
    <div class="page_header" style="">
      <span class="page_title" style="flex: 1;">{{$t("statistics.mileageStatistics")}}</span>

      <quickQuery @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :downloading="downloading" style="text-align: right"/>
    </div>


    <!-- <div style="height: calc(100vh - 220px);overflow: auto;padding-top:20px"> -->
    <div style="padding-top:20px">
      <div style="border: 1px solid #C5D0E2;border-radius: 4px;padding:8px 15px">
        <div class="clearfix" style="display:flex;">
          <div style="padding: 6px 0;font-size:14px">
            <span style="margin-right:30px;font-weight:bold">{{$t("statistics.mileageStatisticsTable")}}</span>
            <span style="margin-right: 40px" v-show="showChartConspt">{{form.beginDate}} ~ {{form.endDate}} （{{days}}{{" " + $t("statistics.day")}}）</span>
            <span  v-show="showChartConspt">{{$t("statistics.vehicleSelected")}}{{vehNum}}</span>
          </div>

          <!--  
           <div style="flex:2;text-align:right">
            <el-button type="primary" size="mini" plain @click="fold" class="foldBtn">
              折叠
              <span class="iconfont" v-if="showChartConspt">&#xe6f3;</span>
              <span class="iconfont" v-else>&#xe6f1;</span>
            </el-button>
          </div> -->

        </div>
        <div style="text-align:center;padding-top:10px">
          <el-row>
            <el-col :span="24">
              <div v-loading="loadingCharts" id="mileageChart" style="width:100%; height:240px;" v-show="showChartConspt"></div>
              <div v-show="!showChartConspt" style="font-size:14px;color:#909399;padding-bottom:15px">{{$t("statistics.noData")}}</div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- <el-card class="card" shadow="never"> 
        <div slot="header" class="clearfix" style="display:flex;">
          <div style="padding: 6px 0;">
            <span style="margin-right: 40px">2023-07-07 00:00:00~2023-07-09 23:59:59（3天）</span>
            <span>已选车辆： 台</span>
          </div>
          <div style="flex:1;text-align:right">
            <el-button type="primary" size="mini" plain @click="fold" class="foldBtn">
              折叠
              <span class="iconfont" v-if="showChartConspt">&#xe6f3;</span>
              <span class="iconfont" v-else>&#xe6f1;</span>
            </el-button>
          </div>
        </div>
        <div style="text-align:center">
          <el-row>
            <el-col :span="24">
              <div id="mileageChart" style="width:100%; height:240px;" v-show="showChartConspt"></div>
            </el-col>
          </el-row>
        </div>
      </el-card> -->
      
      <div  class="container" style="" >
        <el-table :size="size" :data="dataList" @sort-change='sortChange' border style=" width:100%" v-loading="loading"> <!--:height="'calc(100vh - 570px)'" 'calc(100vh - 560px)' 560px  320px-->
          <el-table-column :label='$t("public.OrderIndex")' prop="id" align="center" width="105"></el-table-column>
          <el-table-column :label='$t("statistics.group")' prop="group" align="center" :min-width="160" sortable="custom"></el-table-column>
          <el-table-column :label='$t("vehicle.carNo")' prop="carNo" align="center" :min-width="170" sortable="custom"></el-table-column>
          <el-table-column :label='$t("statistics.beginMileage")+"(km)"' prop="beginMileage" align="center" :min-width="145" sortable="custom"></el-table-column>
          <el-table-column :label='$t("statistics.endMileage")+"(km)"' prop="endMileage" align="center" :min-width="145" sortable="custom"></el-table-column>
          <el-table-column :label='$t("statistics.thisStageMileage")+"(km)"' prop="thisStageMileage" align="center" :min-width="230" sortable="custom"></el-table-column>
          <el-table-column :label='$t("statistics.totalMileage")+"(km)"' prop="totalMileage" align="center" :min-width="175" sortable="custom">
            <template slot-scope="scope">{{inEmpty(scope.row.totalMileage)}}</template>
          </el-table-column>
        </el-table>
      </div>
      <div style="text-align: right ;margin-top:8px" class="pagination" v-show="total>0" >  <!--  -->
         <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="form.pageSize"
            @size-change="handleSizeChange"
          layout="total, prev, pager, next, sizes"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
// import * as echarts from "echarts";
import { mapState } from 'vuex'
import quickQuery from '../components/generalOrQuickQuery.vue'
import language from '@/utils/getLanguageId'
import settings from "@/settings";
export default {
  name: "mileageStatistics",
  components:{quickQuery},
  data(){
    return{
      downloading:false,
      // showChartConspt:true,
      mileageChart:undefined,
      total:0,
      currentPage:1,
      dataList:[],
      mileageChartData:[],
      searchTime:[new Date(),new Date(new Date().getTime() + 24 * 60 * 60 * 1000)],//
      form:{
        // beginDate:"",
        // endDate:"",
        // pageNum:1,
         pageSize:10,
      },
      days:0, //查询的天数
      loading:false,
      loadingCharts:false,
      vehNum:0,
      autoWidth:true,
      LanguageId:1,
      Params: undefined,//排序参数  
      SortFlag: undefined,//1:升序 2:降序
    }
  },
  computed:{
    // height(){
    //   if(this.showChartConspt){
    //     return "calc(100vh - 562px)"
    //   }else return "calc(100vh - 320px)"
    // },
    size() {
      return this.$store.getters.size
    },
    searchShow(){
      return this.searchType == 0 ? true: false;
    },
    ...mapState({
      opened: state => state.app.sidebar.opened,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
    showChartConspt(){
      return this.mileageChartData.length > 0 ? true: false;
    },
  },
  watch:{
    showChartConspt(){
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    opened(val){
       setTimeout(() => {
          this.mileageChart.resize();
       }, 300)
    },
  },
  methods:{
    handleSizeChange(val){
   
      this.form.pageSize = val;
      this.getList();
    },
    sortChange(column){
      // console.log("排序",column, column.prop, column.order);
      this.Params = column.prop;
      this.SortFlag = column.order == "ascending" ? 1 : column.order ? 2 : undefined;
      this.getList();
    },
    inEmpty(row){
        return row == null ? 0 : row;
    },
    fold(){
      this.showChartConspt = !this.showChartConspt;
      if(this.showChartConspt){
        setTimeout(()=>{
          var myEvent = new Event("resize");
          window.dispatchEvent(myEvent);
        },0)

      }
    },
    initChart(){
      this.mileageChart = echarts.init(document.getElementById("mileageChart"));
      var option = {
        grid: {
          left: 15,
          right: 32,
          bottom: 0,
          top: 55,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis', // 关键：双系列需用 axis 触发，确保同时显示两个系列的提示
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            // params 是所有系列的提示数据数组，顺序与 series 一致
            let html = params[0].axisValue + '<br/>'; // 首行显示 X 轴值（如日期）
            
            params.forEach(item => {
              html += `<div style="display: flex; align-items: center; margin: 2px 0;">
                        <span style="display: inline-block; width: 10px; height: 10px; background: ${item.color}; border-radius: 2px; margin-right: 8px;"></span>
                        <span>${item.seriesName}: ${item.value}</span>
                      </div>`;
            });
            
            return html;
          },
          textStyle: { fontSize: 14 }
        },
        legend: {
          // data: ['累计里程(km)', '累计时长(h)']
          data: [this.$t("statistics.accumulatedMileage"), this.$t("statistics.accumulatedDuration")]
        },
        xAxis: [
          {
            type: 'category',
            data: [],//速度
            axisPointer: {
              type: 'shadow'
            },
            axisTick: {
              alignWithLabel: true
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '累计里程(km)',

          },
          {
            type: 'value',
            name: '累计时长(h)',

          }
        ],
        series: [
          {
            name: '累计里程(km)',
            type: 'bar',
            color:"#2A7AFF",
            barWidth:30,
            stack: 'one',
            data: [],
          },
          {
            name: '累计时长(h)',
            type: 'line',
            smooth:true,
            yAxisIndex: 1,
            color:"rgb(113 221 142)",
            lineStyle: {
              color: "rgb(113 221 142)"
            },
            data: [],
          },
        ]
      };
      this.mileageChart.setOption(option);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    handleQuery(val){
      this.form = val;

      let begin,end;
      begin = new Date(this.form.beginDate.slice(0,4),this.form.beginDate.slice(5,7)-1,this.form.beginDate.slice(8)).getTime();
      end = new Date(this.form.endDate.slice(0,4),this.form.endDate.slice(5,7)-1,this.form.endDate.slice(8)).getTime()
      this.days = (end-begin)/(1*24*60*60*1000) + 1;
      // console.log((end-begin)/(1*24*60*60*1000) + 1 );
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
      this.getMileageChartData();
    },
    quickQuery(val){
      this.form = val;

      let begin,end;
      begin = new Date(this.form.beginDate.slice(0,4),this.form.beginDate.slice(5,7)-1,this.form.beginDate.slice(8)).getTime();
      end = new Date(this.form.endDate.slice(0,4),this.form.endDate.slice(5,7)-1,this.form.endDate.slice(8)).getTime()
      this.days = (end-begin)/(1*24*60*60*1000) + 1;
      this.vehicles = this.getSelectedVehicles();
      this.currentPage = 1;
      this.getList();
      this.getMileageChartData();
    },
    getList(){
      this.loading = true;
      this.$api
        .mileageInfo({
          optID: this.$store.getters.operator.OperatorId,//"7044"
          beginDate: this.form.beginDate,//"2022-12-01",
          endDate: this.form.endDate,//"2022-12-31",
          Vehicles:  this.vehicles,//"85092,85167",
          PageNo: this.currentPage,
          PageSize: this.form.pageSize,
          IsExport: 0, // 0是查询 1是下载
          Language: this.LanguageId,
          Params: this.SortFlag   ? this.Params : undefined,
          SortFlag: this.SortFlag ? this.SortFlag : undefined,
        })
        .then((res)=>{
          // console.log(res);
          if(res && res.code == 200){
            this.dataList = res.data;
            this.total = res.recordsTotal;
            
            this.loading = false;
            if(this.total == 0){
              this.$message.info(this.$t("statistics.noData"));
            }
          }
        })
        .catch((e)=>{
          this.loading = false;
          this.dataList = [];
          this.total = 0;
        })
    },
    getMileageChartData(){
      this.loadingCharts = true;
      this.$api
        .mileageChart({
          optID: this.$store.getters.operator.OperatorId,
          vehicles:this.vehicles,//  '98084,102756,124091',
          beginDate: this.form.beginDate,
          endDate: this.form.endDate,
          QueryType:1,
        })
        .then((res) => {
          if(res && res.code == 200){
            this.mileageChartData = res.data;
            this.vehNum = this.selectedVehicles.length == 0 ? this.$t("statistics.allSelect") : this.vehicles.split(",").length + " " + this.$t("statistics.sets");
            if(this.mileageChartData && this.mileageChartData.length > 0){
              
              let xAxis_data = [];
              let mileage_data = [];
              let hour_data = [];
              this.mileageChartData.forEach((e)=>{
                xAxis_data.push(e.date);
                mileage_data.push(e.mileage);
                hour_data.push(e.hour);
              });
              // console.log(xAxis_data,mileage_data,hour_data)
              let kmMin = Math.min(...mileage_data);
              let hMin = Math.min(...hour_data);
              let kmMax = Math.max(...mileage_data);
              let hMax = Math.max(...hour_data);
              let accumulatedMileage = this.$t("statistics.accumulatedMileage");
              let accumulatedDuration = this.$t("statistics.accumulatedDuration");
              // console.log(accumulatedMileage,accumulatedDuration);
              this.mileageChart.setOption({
                xAxis: [
                  {
                    type: 'category',
                    data: xAxis_data,//速度
                    axisPointer: {
                      type: 'shadow'
                    },
                    axisTick: {
                      alignWithLabel: true
                    },
                  }
                ],
                yAxis: [
                  {
                    type: 'value',
                    name: accumulatedMileage,
                    min: 0,
                    max: kmMax,
                    interval: (kmMax - 0)/4,
                    splitNumber: 4,
        
                  },
                  {
                    type: 'value',
                    name: accumulatedDuration,
                    min: 0,
                    max: hMax,
                    interval: (hMax-0)/4,
                    splitNumber: 4,
                  }
                ],
                series: [
                  {
                    name: accumulatedMileage,
                    type: 'bar',
                    color:"#2A7AFF",
                    barWidth:"15px",
                    stack: 'one',
                    data: mileage_data,
                  },
                  {
                    name: accumulatedDuration,
                    type: 'line',
                    smooth:true,
                    yAxisIndex: 1,
                    color:"rgb(113 221 142)",
                    emphasis: {
                      lineStyle: {
                        color: "rgb(113 221 142)", 
                      },
                    },
                    data: hour_data,
                  },
                ]
              })
            }
          }
          this.loadingCharts = false;
        })
        .catch((e)=>{
          this.loadingCharts = false;
        })
      
    },
    download(){

      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api
        .downMileageInfo({
          optID: this.$store.getters.operator.OperatorId,//"7044"
          beginDate: this.form.beginDate,//"2022-12-01",
          endDate: this.form.endDate,//"2022-12-31",
          Vehicles:  this.vehicles,//"85092,85167",
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId,
        })
        .then((res) => {
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t("statistics.mileageStatistics")+that.$t("public.download") + `_${new Date().getTime()}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
          return v[j]
      }))
    },
    setResize(){
      this.mileageChart && this.mileageChart.resize();
    }
  },
  mounted(){
  const currentPath = this.$route.path
    // 从全局变量中取出对应路由的开始时间
    const startTime = settings.routeStartTime[currentPath]
    if (startTime) {
      // 计算耗时（mounted时组件已挂载到DOM，UI基础展示完成）
      const renderTime = Date.now() - startTime
      console.log(`路由 ${currentPath} 渲染耗时：${renderTime}`)
      // 可选：上报到后端或日志系统
      // reportRenderTime(currentPath, renderTime)

      // 清除已计算的开始时间，避免重复计算
      delete settings.routeStartTime[currentPath]
    }
    this.$nextTick(()=>{
      this.initChart();
      this.setResize();
    });
    window.addEventListener('resize',this.setResize)
    this.LanguageId = language(this.$store.getters.locale)

  },
  activated(){
    this.setResize();
    window.addEventListener('resize',this.setResize)
  },
  destroyed() {
    window.removeEventListener('resize', this.setResize)
  },
  deactivated(){
    window.removeEventListener('resize', this.setResize)
  },
}
</script>
<style lang="scss"  scoped>
.iconfont{
  color: #0F1A3A;
  :hover{
    color: #2A7AFF;
  }
}
// .iconfont{
//   font-size: 10px;
// }
.foldBtn{
  ::v-deep .el-button--mini{
    padding: 5px 10px !important;
  }
}
.card   {
  ::v-deep .el-card__header {
    background: #E8F0FF;
    height: 35px;
    padding: 2px 20px;
    /* font-weight: bold; */
    font-size: 14px;
    /* color: #909399; */
  }
  .el-card__body{
    padding: 20px 10px 10px 10px;
  }
}
.el-card{
  background-color: transparent !important;
}

.pagination  {
  ::v-deep .el-pagination button:disabled,.el-pager li,.el-pagination .btn-prev, .el-pagination .btn-next{
    background-color: transparent !important;
  }

}

.container{
  ::v-deep .el-table tr {
      background: transparent;
  }

  ::v-deep .el-table {
      background: transparent;
  }

  ::v-deep .el-table td {
      background: transparent;
  }
}

.input-number   {
  ::v-deep .el-input {
    position: relative;
    &::before {
      content: "km/h";
      position: absolute;
      top: 0;
      right: 25px;
      height: 32px;
      line-height: 35px;
      color: #0F1A3A;
      font-size: 12px;
    }
  }
  ::v-deep .el-input-number {
    &__increase,
    &__decrease {
      background-color: transparent ;
      border: 0 !important;
      width: 25px ;
    }
    .el-icon-arrow-up::before {
      content: "";
    }
    .el-icon-arrow-down::before {
      content: "";
    }
    &.is-controls-right .el-input-number__decrease [class*=el-icon],
    &.is-controls-right .el-input-number__increase [class*=el-icon] {
      transform: scale(1.1);
    }
  }
}
// .selectIcon{
//   .el-icon-arrow-up:before {
//     content: "\e78f";
//   }
//   .el-select .el-input .el-select__caret{
//     color: #0F1A3A;
//   }
// }

</style>

